$(document).ready(function () {
  $(".variant-btn").click(function () {
    $(".product-block--price .save-div").removeClass("show");
    var VariantId = $(this).attr("data-variation-id");
    $("#" + VariantId).addClass("show");
  });


  var onnochange = $(".testproduct__price")
    .text()
    .replace("Rs.", "")
    .replace(",", "");

  if (onnochange > 500.0) {
    $("#overprice").html("Free Shipping");
  } else {
    $("#overprice").html("Free Shipping above" + " <span>Rs. 500</span>");
  }

  $(".variant-btn").on("change", function () {
    let testProductprice = $(".testproduct__price").text();
    let value = testProductprice.replace("Rs.", "").replace(",", "");
    if (value > 500.0) {
      $("#overprice").html("Free Shipping");
    } else {
      $("#overprice").html("Free Shipping above" + " <span>Rs. 500</span>");
    }
  });
});

